import {Link, Box} from '@primer/react'

export function CommitHelpMessage({url}: {url: string}) {
  return (
    <>
      <Box className="text-center">
        <p className="color-fg-muted f6 mt-4">
          Seeing something unexpected? Take a look at the
          <Link href={url}> GitHub commits guide</Link>.
        </p>
      </Box>
    </>
  )
}

try{ CommitHelpMessage.displayName ||= 'CommitHelpMessage' } catch {}